<template>
  <div class="d-flex justify-content-center">
    <div class="self-record">
      <FormKit type="multi-step"
        id="self-record-form"
        submit-label="SelfRecord"
        :actions="false"
        form-class="self-record-form"
        @change="validateForm"
        tab-style="progress"
        :hide-progress-labels="true"
      >
        <FormKit type="step" name="office">
          <h1>Записаться на бесплатную консультацию</h1>
          <div class="self-record-input-group">
            <div class="row row-gap-3">
              <div class="col">
                <SelectBranch
                  :branch="branch"
                  @update:branch="branch = $event"
                />
              </div>
              <RecordHelper :text="'Если вашего офиса нет в списке, позвоните по номеру'" :marginClass="'mt-2'"/>
              <SmartCaptcha
                :callback="setSmartToken"
                :on-success="setSmartToken"
                :class="{'d-none': invisibleCaptcha}"
                id="smart-captcha"
                :sitekey="`${config.yandexSmartCaptchaPublicKey}`"
              />
            </div>
          </div>
          <template #stepNext>
            <FormKit
              type="group"
              :config="{
                classes: {
                  label: 'self-record-form-label',
                  inner: 'self-record-form-inner',
                  input: 'self-record-form-input',
                  wrapper: 'self-record-form-wrapper'
                }
              }"
            >
              <FormKit
                type="button"
                data-next="true"
                @click.prevent="verifyCaptchaAndNext"
                :disabled="!branch"
                outer-class="form-kit-btn form-kit-btn__red mt-3"
              >
                Выбрать время
              </FormKit>
            </FormKit>
          </template>
        </FormKit>
        <FormKit type="step" name="datetime">
          <h1>Выберите время и дату</h1>
          <div class="self-record-input-group">
            <div class="row row-gap-3">
              <div class="col">
                <CalendarDateList
                  :date="date"
                  @update:date="date = $event"
                  :branch="branch"
                />
                <CalendarTimeList
                  :time="time"
                  @update:time="time = $event"
                  :branch="branch"
                  :date="date"
                  :type="'step'"
                />
              </div>
            </div>
          </div>
          <template #stepPrevious></template>
          <template #stepNext="{ handlers }">
            <FormKit
              type="group"
              :config="{
                classes: {
                  label: 'self-record-form-label',
                  inner: 'self-record-form-inner',
                  input: 'self-record-form-input',
                  wrapper: 'self-record-form-wrapper'
                }
              }"
            >
              <FormKit
                type="submit"
                data-next="true"
                @click="handlers.incrementStep(1)()"
                :disabled="!time || !date"
                outer-class="form-kit-btn form-kit-btn__red mt-3"
              >
                Подтвердить
              </FormKit>
              <RecordHelper :marginClass="'mt-4'"/>
            </FormKit>
          </template>
        </FormKit>
        <FormKit type="step" name="contact">
          <h1>Введите контактные данные</h1>
          <div class="self-record-input-group">
            <div class="row row-gap-3">
              <InputName
                :name="name"
                @update:name="name = $event"
              />
              <InputMaskFormKit
                v-model="phone"
                mask="+7 (9##) ###-##-##"
                placeholder="+7 (9**) ***-**-**"
                :defaultValue="storePhone"
              />
              <RecordHelper :marginClass="'mb-4'"/>
            </div>
          </div>
          <template #stepPrevious></template>
          <template #stepNext>
            <FormKit
              type="group"
              :config="{
                classes: {
                  label: 'self-record-form-label',
                  inner: 'self-record-form-inner',
                  input: 'self-record-form-input',
                  wrapper: 'self-record-form-wrapper'
                }
              }"
            >
              <div class="row">
                <div class="col">
                  <div class="submit-form d-flex flex-column">
                    <FormKit
                      type="submit"
                      @click="submitHandler"
                      :disabled="!validateForm() || loadSubmit"
                      outer-class="form-kit-btn form-kit-btn__red"
                    >
                      {{ loadSubmit ? 'Загрузка...' : 'Записаться' }}
                    </FormKit>
                    <p class="mt-4">Отправляя форму, вы соглашаетесь с <a class="link-record" :href="storeGlobalConfig.attempt_link" target="_blank">условиями
                      обработки персональных данных</a></p>
                  </div>
                </div>
              </div>
            </FormKit>
          </template>
        </FormKit>
      </FormKit>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { useRoute } from 'vue-router'
import { addDays, format } from 'date-fns';
import { SmartCaptcha } from 'vue3-smart-captcha';
import { getNode } from '@formkit/core';

import config from '@/../config';
import CalendarDateList from '@/components/Calendar/CalendarDateList.vue';
import CalendarTimeList from '@/components/Calendar/CalendarTimeList.vue';
import InputMaskFormKit from '@/components/Inputs/InputMaskFormKit.vue';
import RecordHelper from '@/components/Records/RecordHelper.vue';
import SelectBranch from '@/components/Inputs/SelectBranch.vue';
import InputName from '@/components/Inputs/InputName.vue';

export default {
  name: 'FormRecord',
  components: {
    CalendarDateList,
    CalendarTimeList,
    SelectBranch,
    InputName,
    InputMaskFormKit,
    SmartCaptcha,
    RecordHelper
  },
  computed: {
    ...mapGetters({
      storePhone: 'getPhone',
      storeName: 'getName',
      storeContactHash: 'getContactHash',
      storeActiveCons: 'getActiveCons',
      storePersonal: 'getPersonal',
      storeGlobalConfig: 'getGlobalConfig'
    })
  },
  data: () => {
    return {
      phone: '',
      name: '',
      date: '',
      branch: '',
      time: '',
      smart_token: '',
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      utm_content: '',
      utm_term: '',
      agent_ref: '',
      attributio: '',
      x_user_id: '',
      is_editing: '',
      loadSubmit: false,
      config: config,
      invisibleCaptcha: true,
    }
  },
  methods: {
    addDays,
    format,
    ...mapActions(['formRecord', 'processPersonalLink']),
    ...mapMutations(['setContactHash']),

    validateForm () {
      return !!(
        /^[А-ЯЁа-яё]+(\s[А-ЯЁа-яё]+)*$/.test(this.name) &&
        /^\+7\s\(9\d{2}\)\s\d{3}-\d{2}-\d{2}$/.test(this.phone) &&
        this.branch && this.time && this.smart_token && this.date
      );
    },

    verifyCaptchaAndNext() {
      if (this.smart_token) {
        getNode('self-record-form').next();
      }
      try {
        window.smartCaptcha.execute();
        getNode('self-record-form').next();
      } catch (e) {
        this.invisibleCaptcha = false;
      }
    },

    setSmartToken (token) {
      this.smart_token = token;
    },

    async submitHandler () {
      this.loadSubmit = true;
      await this.formRecord({
        name: this.name,
        phone: this.phone,
        branch: this.branch,
        date: this.date,
        time: this.time,
        smart_token: this.smart_token,
        utm_source: this.utm_source,
        utm_medium: this.utm_medium,
        utm_campaign: this.utm_campaign,
        utm_content: this.utm_content,
        utm_term: this.utm_term,
        attributio: this.attributio,
        x_user_id: this.x_user_id,
        agent_ref: this.agent_ref
      }).then(() => {
        this.$router.push({
          name: 'FormRecordConfirm',
          query: { 'is_editing': this.is_editing }
        });
      }).finally(() => this.loadSubmit = false);
    },

    mountData() {
      const {
        query: {
          utm_source,
          utm_medium,
          utm_campaign,
          utm_content,
          utm_term,
          attributio,
          x_user_id,
          agent_ref,
          is_editing
        }
      } = useRoute();

      let personalCount = Object.keys(this.storePersonal).length;
      let activeConsCount = Object.keys(this.storeActiveCons).length;

      this.utm_source = localStorage.utm_source || utm_source || (personalCount > 0 ? this.storePersonal.utm_source : '');
      this.utm_medium = localStorage.utm_medium || utm_medium || '';
      this.utm_campaign = localStorage.utm_campaign || utm_campaign || (personalCount > 0 ? this.storePersonal.utm_campaign : '');
      this.utm_content = localStorage.utm_content || utm_content || (personalCount > 0 ? this.storePersonal.utm_content : '');
      this.utm_term = localStorage.utm_term || utm_term || '';
      this.agent_ref = localStorage.agent_ref || agent_ref || '';
      this.attributio = attributio ?? '';
      this.x_user_id = x_user_id || (personalCount > 0 ? this.storePersonal.x_user_id : '');
      this.is_editing = is_editing || 0;
      this.date = activeConsCount > 0 ? format(this.storeActiveCons.lastDate, 'yyyy-MM-dd') : format(addDays(new Date(), 1), 'yyyy-MM-dd');
      this.phone = this.storePhone ?? '';

      if (localStorage.utm_source === '' || localStorage.utm_source === undefined) {
        localStorage.utm_source = utm_source === undefined ? '' : utm_source;
      }
      if (localStorage.utm_medium === '' || localStorage.utm_medium === undefined) {
        localStorage.utm_medium = utm_medium === undefined ? '' : utm_medium;
      }
      if (localStorage.utm_campaign === '' || localStorage.utm_campaign === undefined) {
        localStorage.utm_campaign = utm_campaign === undefined ? '' : utm_campaign;
      }
      if (localStorage.utm_content === '' || localStorage.utm_content === undefined) {
        localStorage.utm_content = utm_content === undefined ? '' : utm_content;
      }
      if (localStorage.utm_term === '' || localStorage.utm_term === undefined) {
        localStorage.utm_term = utm_term === undefined ? '' : utm_term;
      }
      if (localStorage.agent_ref === '' || localStorage.agent_ref === undefined) {
        localStorage.agent_ref = agent_ref === undefined ? '' : agent_ref;
      }
    },
  },

  async beforeMount() {
    this.mountData();

    if (sessionStorage.contact_hash && !this.storeContactHash) {
      this.setContactHash(sessionStorage.contact_hash)
      const route = useRoute();
      const queryParams = {};

      Object.keys(route.query).forEach(key => {
        queryParams[key] = encodeURIComponent(route.query[key])
      });
      queryParams['contact_hash'] = sessionStorage.contact_hash;
      const response = await this.processPersonalLink(
        (new URLSearchParams(queryParams)).toString()
      );
      if (response.status === 200 && response?.data?.code === 'ACTIVE_CONS_FOUND' && !this.is_editing) {
        this.$router.push('/exist');
      }
    }
  }
};
</script>

<style lang="scss">
.formkit-tabs {
  display: none
}
.formkit-wrapper, .formkit-fieldset {
  --fk-max-width-input: 100%
}
.formkit-outer[data-type='multi-step'] > .formkit-wrapper {
  max-width: 100%;
}
</style>
